import {
  UPDATE_VISIT_LOCATION,
  UPDATE_SEARCH_ADDRESS,
  UPDATE_SEARCH_GEOCODE,
  UPDATE_SEARCH_CITY,
  CLEAR_SEARCH_ADDRESS,
  RESET_SEARCH_ADDRESS_CLEARED,
  UPDATE_SEARCH_COUNTY,
  UPDATE_SEARCH_STATE,
  UPDATE_STATE_CONFIG,
  UPDATE_SEARCH_ZIPCODE,
} from "../actions/types"
import { Coordinates, StateConfig } from "../types"
import type {
  ClearSearchAddressAction,
  ResetSearchAddressClearedAction,
  UpdateSearchAddressAction,
  UpdateSearchCityAction,
  UpdateSearchCountyAction,
  UpdateSearchGeocodeAction,
  UpdateSearchStateAction,
  UpdateStateConfigAction,
  UpdateVisitLocationAction,
  UpdateSearchZipcodeAction,
} from "../actions/locationActions"

export interface ReduxLocationState {
  visitLocation: string | null
  searchAddress: string | null
  searchCity: string | null
  searchGeocode: Coordinates | null
  searchCounty: string | null
  searchState: string | null
  searchZipcode: string | null
  searchAddressCleared: boolean
  stateConfig: StateConfig | null
}

const INITIAL_STATE: ReduxLocationState = {
  visitLocation: null,
  searchAddress: null,
  searchCity: null,
  searchGeocode: null,
  searchCounty: null,
  searchState: null,
  searchZipcode: null,
  searchAddressCleared: false,
  stateConfig: null,
}

type Actions =
  | UpdateVisitLocationAction
  | ResetSearchAddressClearedAction
  | ClearSearchAddressAction
  | UpdateSearchAddressAction
  | UpdateSearchCityAction
  | UpdateSearchStateAction
  | UpdateSearchCountyAction
  | UpdateSearchGeocodeAction
  | UpdateStateConfigAction
  | UpdateSearchZipcodeAction

export default (state = INITIAL_STATE, action: Actions): ReduxLocationState => {
  switch (action.type) {
    case UPDATE_VISIT_LOCATION:
      return { ...state, visitLocation: action.payload }
    case UPDATE_SEARCH_ADDRESS:
      return { ...state, searchAddress: action.payload }
    case UPDATE_SEARCH_GEOCODE:
      return { ...state, searchGeocode: action.payload }
    case UPDATE_SEARCH_CITY:
      return { ...state, searchCity: action.payload }
    case UPDATE_SEARCH_COUNTY:
      return { ...state, searchCounty: action.payload }
    case UPDATE_SEARCH_STATE:
      return { ...state, searchState: action.payload }
    case UPDATE_STATE_CONFIG:
      return { ...state, stateConfig: action.payload }
    case UPDATE_SEARCH_ZIPCODE:
      return { ...state, searchZipcode: action.payload }
    case CLEAR_SEARCH_ADDRESS:
      return {
        ...state,
        searchCity: null,
        searchAddress: null,
        searchCounty: null,
        searchAddressCleared: true,
        searchState: null,
        searchZipcode: null,
        stateConfig: null,
        searchGeocode: null,
      }
    case RESET_SEARCH_ADDRESS_CLEARED:
      return { ...state, searchAddressCleared: false }
    default:
      return state
  }
}
